import config from '@/config';

export default {
  data() {
    return {
      hasValidLogo: false,
    };
  },
  computed: {
    logo() {
      return `${config.accountLogosRoot}/${this.account}.png`;
    },
  },
  methods: {
    preloadLogo() {
      const image = new Image();
      image.onload = () => {
        this.hasValidLogo = true;
      };
      image.onerror = () => {
        this.hasValidLogo = false;
      };
      image.src = `${config.accountLogosRoot}/${this.account}.png`;
    },
  },
};
